export default {"src":"/_next/static/media/finland.02e61b0c.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};